/**
 * Automatically imports all the modules and exports as a single module object
 */
 const requireModule = require.context('.', true,  /\.store\.js$/);
 const modules = {};
 
 requireModule.keys().forEach(filename => {
    const moduleName = filename.split('/')[1];
    modules[moduleName] = requireModule(filename).default || requireModule(filename);
 });
 
 export default modules;